import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import { combineReducers } from '@reduxjs/toolkit';
import sessionStorage from 'redux-persist/lib/storage/session'; // Use sessionStorage for persistence
import sessionReducer from './SessionSlice';
import accountInfoReducer from './AccountInfoSlice';

// Create persist config for the session reducer
const sessionPersistConfig = {
  key: 'session',
  storage: sessionStorage,
};

// Create persist config for the accountInfo reducer
const accountInfoPersistConfig = {
  key: 'accountInfo',
  storage: sessionStorage,
};

// Apply persistReducer to both reducers
const persistedSessionReducer = persistReducer(sessionPersistConfig, sessionReducer);
const persistedAccountInfoReducer = persistReducer(accountInfoPersistConfig, accountInfoReducer);

// Combine both persisted reducers into one root reducer
const rootReducer = combineReducers({
  session: persistedSessionReducer,
  accountInfo: persistedAccountInfoReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable serializable check to allow non-serializable values like sessionStorage
    }),
});

// Create persistor for handling persistence
export const persistor = persistStore(store);
